import React, { Component, createContext } from "react";

export const ValueContext = createContext();

export class Context extends Component {
  state = {
    alert_show: false,
    alert_message: "",
    alert_type: "",
  };

  setAlert = (alert_show, alert_message, alert_type) =>
    this.setState({ alert_show, alert_message, alert_type });

  resetAlert = () => this.setState({ alert_show: false });

  render() {
    return (
      <ValueContext.Provider
        value={{
          ...this.state,
          setAlert: this.setAlert,
          resetAlert: this.resetAlert,
        }}
      >
        {this.props.children}
      </ValueContext.Provider>
    );
  }
}

export default Context;
